import React from 'react'

import AssessmentBar from '../AssessmentBar/AssessmentBar'
import Button from '../Button/Button'

import {
  WorkoutQuestionContainer,
  WorkoutTitle,
  WorkoutQuestion,
  WorkoutAnswer,
  RevealButtonContainer,
  AssessmentBarContainer,
  NextButtonContainer,
} from './WorkoutQuestion-styled'

export default ({
  title,
  question,
  onRevealAnswer,
  answer,
  displayAnswer,
  onSelect,
  response,
  onGoToNextQuestion,
  fadeInQuestion = false,
  fadeInQuestionDuration = '0.8s',
}) => (
  <WorkoutQuestionContainer>
    <WorkoutTitle fadeInQuestion={fadeInQuestion} fadeInQuestionDuration={fadeInQuestionDuration}>
      {title}
    </WorkoutTitle>
    <WorkoutQuestion
      fadeInQuestion={fadeInQuestion}
      fadeInQuestionDuration={fadeInQuestionDuration}
    >
      {question}
    </WorkoutQuestion>
    {!displayAnswer && (
      <RevealButtonContainer>
        <Button onClick={onRevealAnswer} title="Reveal Answer" large />
      </RevealButtonContainer>
    )}
    {displayAnswer && <WorkoutAnswer>Answer: {answer}</WorkoutAnswer>}
    {displayAnswer && (
      <AssessmentBarContainer>
        <AssessmentBar onSelect={onSelect} selectedBoxId={response} />
      </AssessmentBarContainer>
    )}
    {displayAnswer &&
      response && (
        <NextButtonContainer>
          <Button onClick={onGoToNextQuestion} title="Next" fullWidth large />
        </NextButtonContainer>
      )}
  </WorkoutQuestionContainer>
)



// WEBPACK FOOTER //
// ./src/component/_presentational/WorkoutQuestion/WorkoutQuestion.jsx